// Lesson 5: Rekap dan Percakapan Pendek - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 5: Rekap dan Percakapan Pendek (Review & Short Conversations)
export const unit1Lesson5ExtendedWordBank: Word[] = [
    // Core question words  
    {
        id: 101,
        batak: "ᯀᯍ",
        latin: ["a", "ha"],
        indonesia: "Siapa",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯍ", latin: "ha" }
        ]
    },
    {
        id: 102,
        batak: "ᯘᯀᯤ",
        latin: ["sai"],
        indonesia: "Dari mana",
        syllable_mapping: [
            { batak_char: "ᯘᯀᯤ", latin: "sai" }
        ]
    },
    {
        id: 103,
        batak: "ᯇᯪᯒᯬ",
        latin: ["pi", "ro"],
        indonesia: "Berapa",
        syllable_mapping: [
            { batak_char: "ᯇᯪ", latin: "pi" },
            { batak_char: "ᯒᯬ", latin: "ro" }
        ]
    },
    {
        id: 104,
        batak: "ᯀᯉᯃᯒᯉ᯲ᯔᯮ",
        latin: ["a", "nak", "kon", "mu"],
        indonesia: "namamu",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯉᯃ", latin: "nak" },
            { batak_char: "ᯒᯉ᯲", latin: "kon" },
            { batak_char: "ᯔᯮ", latin: "mu" }
        ]
    },
    {
        id: 105,
        batak: "ᯀᯘᯇᯔᯮ",
        latin: ["a", "sal", "mu"],
        indonesia: "asalmu",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯘᯇ", latin: "sal" },
            { batak_char: "ᯔᯮ", latin: "mu" }
        ]
    },
    {
        id: 106,
        batak: "ᯖᯮᯀᯔᯮ",
        latin: ["tu", "a", "mu"],
        indonesia: "umurmu",
        syllable_mapping: [
            { batak_char: "ᯖᯮ", latin: "tu" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯔᯮ", latin: "mu" }
        ]
    },
    // Additional vocabulary from conversation
    {
        id: 107,
        batak: "ᯂᯬᯒᯘ",
        latin: ["ho", "ras"],
        indonesia: "Salam/halo",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" },
            { batak_char: "ᯒᯘ", latin: "ras" }
        ]
    },
    {
        id: 108,
        batak: "ᯘᯤ",
        latin: ["si"],
        indonesia: "si",
        syllable_mapping: [
            { batak_char: "ᯘᯤ", latin: "si" }
        ]
    },
    {
        id: 109,
        batak: "ᯞᯘᯖᯒᯤ",
        latin: ["Les", "ta", "ri"],
        indonesia: "Lestari",
        syllable_mapping: [
            { batak_char: "ᯞᯘ", latin: "Les" },
            { batak_char: "ᯖ", latin: "ta" },
            { batak_char: "ᯒᯤ", latin: "ri" }
        ]
    },
    {
        id: 110,
        batak: "ᯇᯬᯒᯘᯀ",
        latin: ["Por", "se", "a"],
        indonesia: "Porsea",
        syllable_mapping: [
            { batak_char: "ᯇᯬᯒ", latin: "Por" },
            { batak_char: "ᯘ", latin: "se" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 111,
        batak: "ᯖᯮᯀᯀᯮ",
        latin: ["tu", "a", "au"],
        indonesia: "umurku",
        syllable_mapping: [
            { batak_char: "ᯖᯮ", latin: "tu" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 112,
        batak: "22",
        latin: ["dua", "puluh", "dua"],
        indonesia: "22",
        syllable_mapping: [
            { batak_char: "22", latin: "dua puluh dua" }
        ]
    },
    {
        id: 113,
        batak: "ᯖᯀᯬᯉ᯲",
        latin: ["ta", "on"],
        indonesia: "tahun",
        syllable_mapping: [
            { batak_char: "ᯖᯀ", latin: "ta" },
            { batak_char: "ᯬᯉ᯲", latin: "on" }
        ]
    },
    // Shared vocabulary from previous lessons
    {
        id: 114,
        batak: "ᯑᯬ",
        latin: ["do"],
        indonesia: "adalah",
        syllable_mapping: [
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 115,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 116,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 117,
        batak: "ᯤᯀ",
        latin: ["ia"],
        indonesia: "dia",
        syllable_mapping: [
            { batak_char: "ᯤᯀ", latin: "ia" }
        ]
    },
    {
        id: 999,
        batak: "",
        latin: ["."],
        indonesia: "",
        syllable_mapping: [{ batak_char: "", latin: "-" }],
    },
];

// Helper function to create word dictionary
export const createUnit1Lesson5WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
